export default __webpack_public_path__ + "static/char-21-a0a90b7a2da9181074e069dbb12dd2b4.webp";